import { ButtonGroup } from 'ui/buttonGroupV2/ButtonGroup';
import { BUTTON_GROUP_TYPES } from 'ui/buttonGroupV2/types';
import { noop } from 'utils/noop';

// type Props = {
//   /** An additional table row class. */
//   className: string,
//   /**
//    * Function to run when page size is changed.
//    * ```
//    * onChangePageSize(e, pageSizeProps)
//    * ```
//    * @param { Object } e: The change event.
//    * @param { Object } pageSizeProps: Props of the selector including the updated pageSize.
//    */
//   onChangePageSize: () => void,
//   /** Array of page sizes to display. */
//   pageSizes: [number],
//   /** Currently selected page size. */
//   pageSize: number,
// };

export const PageSizeSelector = (props) => {
  const { className, onChangePageSize = noop, pageSize = 10, pageSizes = [10, 20, 50] } = props;

  const buttons = pageSizes.map((value) => ({
    id: `${value}-page-size`,
    'data-test': `${value}-page-size`,
    children: value,
    onClick: (e) => onChangePageSize(e, { pageSize: value }),
  }));

  return (
    <ButtonGroup
      className={className}
      data-role="page-sizing"
      defaultSelectedIds={[`${pageSize}-page-size`]}
      options={buttons}
      type={BUTTON_GROUP_TYPES.SINGLE_SELECT}
    />
  );
};
